const state = {
  notifications: [],
};

const getters = {};

const actions = {
  async initNotificationNative() {
    const status = Notification?.permission;

    if (status === 'granted' || status === 'denied') {
      return status;
    }

    const permission = await Notification.requestPermission();
    return permission;
  },
  // @notification: {title: String, body: String }
  async showNotificationNative({ dispatch, commit }, notification) {
    if (!notification) return false;

    const status = await dispatch('initNotificationNative');
    
    if (status !== 'granted') {

      commit('addSnackbarMessage', {
          message: 'Notification permission denied. Please enable it in your browser settings.',
          show: true,
          timeout: 10000
        }, { root: true });

      return false;
    }
    
    const _notification = new Notification(notification.title, {
      body: notification.body,
      icon: '/favicon.png',
    });


    _notification.onclick = function (event) {
      event.preventDefault(); // prevent the browser from focusing the Notification's tab
      if (window.location.pathname !== '/livechat') {
        window.focus();
        window.location.href = '/livechat';
      } else {
        window.focus();
      }
    };

    _notification.onerror = function (event) {
      const errorMessage = event?.message || 'An error occurred while showing the notification.';
      commit('addSnackbarMessage', { message: errorMessage, show: true, timeout: 10000 }, { root: true });
    };
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
